import styled from 'styled-components';
import { DocumentsListInfoText } from './PortalDocumentsListInfoText';
import { darkGrayText, mvpGrayText } from 'src/styles';

export const InfoText = styled(DocumentsListInfoText)`
  display: block;
  font-size: 0.8em;
  margin: 0 0 1em;
  color: ${darkGrayText};
`;

export const MvpInfoText = styled(DocumentsListInfoText)`
  font-family: 'DanskeRegularNew', 'Tahoma', Sans-Serif, sans-serif;
  font-size: 13px;
  margin: 6px 0;
  color: ${mvpGrayText};
`;
